import { ServiceTypeCategory } from 'components/product-order-popup/common'
import { type PatientWithVisitInfo } from 'types/types'

/**
 * Service type abbreviations (in addition to MAT, which is matched by category)
 * whose visits should surface the PDMP card. The abbreviation is a stable,
 * environment-independent key set on the service type (e.g. "UC" = Urgent Care).
 */
const PDMP_ELIGIBLE_ABBREVIATIONS = ['UC'] // Urgent Care

/**
 * Whether the PDMP card should render for a given visit's service type.
 *
 * Addiction Treatment is matched by its category (unchanged, so there is no
 * regression to existing MAT behavior); additional service types are matched by
 * their abbreviation allowlist.
 */
export const shouldShowPdmp = (
  info: Pick<PatientWithVisitInfo, 'ServiceTypeCategory' | 'ServiceTypeAbbreviation'>,
): boolean =>
  info.ServiceTypeCategory === ServiceTypeCategory.MedicationAssistedTreatment ||
  PDMP_ELIGIBLE_ABBREVIATIONS.includes(info.ServiceTypeAbbreviation ?? '')
